<template>
	<div>
			<div class="home_topic">
				<div class="topic-item" style="padding-left: 6px;" @click="activityTo({link:'newArrivals'})">
					<img class="topic-item-icon" src="../../../assets/image/home/newArrivals@2x.png" />
				</div>
				<div class="topic-item" style="padding-right: 6px;" @click="activityTo({link:'redGoods'})">
					<img class="topic-item-icon" src="../../../assets/image/home/redGoods@2x.png" />
				</div>
  		</div>
			<div class="home_topic">
				<div class="topic-item" style="padding-left: 6px;" @click="activityTo({link:'online'})">
					<img class="topic-item-icon" src="../../../assets/image/home/vip@2x.png" />
				</div>
				<div class="topic-item" style="padding-right: 6px;" @click="activityTo({link:'discount'})">
					<img class="topic-item-icon" src="../../../assets/image/home/activity@2x.png" />
				</div>
  		</div>
			<div class="home_topic">
				<div class="topic-item" style="padding-left: 6px;" @click="activityTo({link:'flashSale'})">
					<img class="topic-item-icon" src="../../../assets/image/home/limitedTime@2x.png" />
				</div>
				<div class="topic-item" style="padding-right: 6px;" @click="activityTo({link:'promotionList'})">
					<img class="topic-item-icon" src="../../../assets/image/home/promotion@2x.png" />
				</div>
  		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ENUM } from '../../../const/enum.js';

export default {
  name: "Hometopic",
  computed: {
  	...mapState({
		isOnline: state => state.auth.isOnline,
		orderStatus: state => state.order.orderStatus,
	}),
	},
  methods: {
  	activityTo: function(item) {
			this.$router.push({ name: item.link});
  	}
  }
};
</script>
<style lang="scss" scoped>
.home_topic {
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding: 4px 0;
  background: #FFFFFF;
  .topic-item {
    display: flex;
    flex-direction: column;
    align-items: center;
		width:46%;
		height: 100px;
    .topic-item-icon {
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .topic-item-title {
      color: #333333;
      font-size: 12px;
      margin-top: 3px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/home/child/HomeTopic.vue